import React, { useEffect, useRef, useState, useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'


// Components
import AjaxController from '../system/ajaxController';

// SemanticUI components
import { Segment, Image, Icon, Button, Label, LabelGroup, Divider, Grid, GridRow, GridColumn, Table, TableBody, TableRow, TableHeader, TableHeaderCell, TableCell } from 'semantic-ui-react';
import { ListItem, ListHeader, ListDescription, ListContent, List } from 'semantic-ui-react'
import { Header, HeaderContent } from 'semantic-ui-react'

// Redux slices
import { setContractId, setObjectId } from '../../appSlice'
import { setActivePage, setUser, setToken, openModal } from '../../appSlice';
import { addResult, setResult } from './searchSlice';
import { resetObject, setObjectData, setMetaData } from './../object/objectSlice';
import { hideSidebar, abortEdit } from '../contract/contractSlice';

/* Snackbar
 * https://notistack.com/api-reference
 */
import { useSnackbar } from 'notistack';

// Styles
import './search.css';



/**
 * 
 * @param {Object} hotel 
 * @returns 
 */
const Max2SearchResultItem = ({hotel}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();



  /**
   * 
   * @param {integer} oid 
   */
  const handleOpenObjectClick = (oid) => {
    dispatch(resetObject());
    dispatch(setActivePage('OBJECT'));
    dispatch(setObjectId(oid));
  } 


  /**
   * 
   * @param {integer} oid 
   */
  const handleOpenContractClick = (cid, oid) => {
    dispatch(hideSidebar());
    dispatch(abortEdit());
    dispatch(resetObject());

    dispatch(setActivePage('CONTRACT'));
    dispatch(setObjectId(oid));
    dispatch(setContractId(cid));
  }

  //
  const destinationItems = hotel.destinations ? hotel.destinations.map((destinationItem) => {
    return (
      <Label circular key={destinationItem}><Icon name='globe' /> {destinationItem}&nbsp;&nbsp;</Label>
    )
  }) : <></>;

  //
  let contracts = [];
  if (hotel.contracts) {
    hotel.contracts.forEach(element => {
      contracts.push(element)
    });
    contracts.sort((a, b) => b.id - a.id);
  }
  const contractItems = !contracts ? <></> : contracts.map((contractItem, contractIndex) => {
    return contractIndex > 4 ? <></> : 
      contractItem.status === 1 
      ? <Label circular as="a" color='green'  style={{width: "50px"}} key={contractItem.id} title={t('search.result.openContract', {season: contractItem.season})} onClick={() => handleOpenContractClick(contractItem.id, hotel.id)}>{contractItem.season}</Label>
      : <Label circular as="a" color='orange' style={{width: "50px"}} key={contractItem.id} title={t('search.result.openContract', {season: contractItem.season})} onClick={() => handleOpenContractClick(contractItem.id, hotel.id)}>{contractItem.season}</Label>
    ;
  });

  //
  const isActive = hotel.active === 'ja' || hotel.markets?.hlx || hotel.markets?.tzo || hotel.markets?.ygo ? true : false;
  const activeItem = hotel.active === 'ja' ? <Label key='l1' circular color='purple' style={{backgroundColor: '#891b55'}}><Icon name='check' /> {t('common.active')}</Label> : <></>;
  const hlxItem = hotel.markets?.hlx ? <Label key='l2' circular color='purple' style={{backgroundColor: '#891b55'}}><Icon name='check' /> {t('common.hlx')}</Label> : <></>;
  const tzoItem = hotel.markets?.tzo ? <Label key='l3' circular color='purple' style={{backgroundColor: '#891b55'}}><Icon name='check' /> {t('common.tzo')}</Label> : <></>;
  const ygoItem = hotel.markets?.ygo ? <Label key='l4' circular color='purple' style={{backgroundColor: '#891b55'}}><Icon name='check' /> {t('common.ygo')}</Label> : <></>;

  return (
    <ListItem>
      <ListContent floated='right'>
        <Button circular primary icon='folder open outline' title={t('search.result.openHotel', {name: hotel.name})} onClick={() => handleOpenObjectClick(hotel.id)} /><br />
        <Button circular basic icon='pin' style={{marginTop: '5px'}} title={t('search.result.pinHotel', {name: hotel.name})} onClick={() => { dispatch(openModal({type: 'watchlist', data: {type: 'OBJECT', id: hotel.id, name: hotel.code}}))}} />
      </ListContent>
      <Image rounded size='tiny' src={hotel.preview_url} />
      <ListContent>
        <div key='ldesc0'>
          <ListHeader style={{display: 'inline-block'}}>{hotel.code}</ListHeader>
          <ListDescription key='ldesc1' style={{display: 'inline-block', marginTop: '5px', marginLeft: '10px'}}>{hotel.name}, {hotel.city}</ListDescription>
        </div>
        <ListDescription key='ldesc2' style={{marginTop: '5px'}}>
          Giata-ID: {hotel.giata}
        </ListDescription>
        <ListDescription key='ldesc3' style={{marginTop: '5px'}}>
          <LabelGroup>
            {isActive && <span style={{marginRight: "25px"}}>{activeItem}{hlxItem}{tzoItem}{ygoItem}</span>}
            <span style={{marginRight: "25px"}}>{t('search.result.header.3lc')}: {destinationItems}</span>
            {contractItems.length ? (<>{t('search.result.header.contracts')}: {contractItems}</>) : <></>}
          </LabelGroup>
        </ListDescription>
      </ListContent>
    </ListItem>
  )
}



/**
 * 
 * @param {Object} hotel 
 * @returns 
 */
const Max2SearchResultRow = ({hotel}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();



  /**
   * 
   * @param {integer} oid 
   */
  const handleOpenObjectClick = (oid) => {
    dispatch(resetObject());
    dispatch(setActivePage('OBJECT'));
    dispatch(setObjectId(oid));
  } 


  /**
   * 
   * @param {integer} oid 
   */
  const handleOpenContractClick = (cid, oid) => {
    dispatch(hideSidebar());
    dispatch(abortEdit());
    dispatch(resetObject());

    dispatch(setActivePage('CONTRACT'));
    dispatch(setObjectId(oid));
    dispatch(setContractId(cid));
  }

  //
  const destinationItems = hotel.destinations ? hotel.destinations.map((destinationItem) => {
    return (
      <Label circular key={destinationItem}><Icon name='globe' /> {destinationItem}&nbsp;&nbsp;</Label>
    )
  }) : <></>;

  //
  let contracts = [];
  if (hotel.contracts) {
    hotel.contracts.forEach(element => {
      contracts.push(element)
    });
    contracts.sort((a, b) => b.id - a.id);
  }
  const contractItems = !contracts ? <></> : contracts.map((contractItem, contractIndex) => {
    return contractIndex > 4 ? <></> : 
      contractItem.status === 1 
      ? <Label circular as="a" color='green'  style={{width: "40px"}} key={contractItem.id} title={t('search.result.openContract', {season: contractItem.season})} onClick={() => handleOpenContractClick(contractItem.id, hotel.id)}>{contractItem.season}</Label>
      : <Label circular as="a" color='orange' style={{width: "40px"}} key={contractItem.id} title={t('search.result.openContract', {season: contractItem.season})} onClick={() => handleOpenContractClick(contractItem.id, hotel.id)}>{contractItem.season}</Label>
    ;
  });

  //
  const activeItem = hotel.active === 'ja' ? <Label key='l1' circular color='purple' style={{backgroundColor: '#891b55'}}><Icon name='check' /> {t('common.active')}</Label> : <></>;
  const hlxItem = hotel.markets?.hlx ? <Label key='l2' circular color='purple' style={{backgroundColor: '#891b55'}}><Icon name='check' /> {t('common.hlx')}</Label> : <></>;
  const tzoItem = hotel.markets?.tzo ? <Label key='l3' circular color='purple' style={{backgroundColor: '#891b55'}}><Icon name='check' /> {t('common.tzo')}</Label> : <></>;
  const ygoItem = hotel.markets?.ygo ? <Label key='l4' circular color='purple' style={{backgroundColor: '#891b55'}}><Icon name='check' /> {t('common.ygo')}</Label> : <></>;

  return (
    <TableRow key={hotel.id + '-' + hotel.giata}>
      <TableCell><Image rounded size='tiny' src={hotel.preview_url} /></TableCell>
      <TableCell>{hotel.code}</TableCell>
      <TableCell>{hotel.name}</TableCell>
      <TableCell>{hotel.giata}</TableCell>
      <TableCell>{destinationItems}</TableCell>
      <TableCell>
        {activeItem}
        {hlxItem}
        {tzoItem}
        {ygoItem}
      </TableCell>
      <TableCell>{contractItems}</TableCell>
      <TableCell>
        <Button circular primary icon='folder open outline'            title={t('search.result.openHotel', {name: hotel.name})} onClick={() => handleOpenObjectClick(hotel.id)} /><br />
        <Button circular basic   icon='pin' style={{marginTop: '5px'}} title={t('search.result.pinHotel', {name: hotel.name})} onClick={() => { dispatch(openModal({type: 'watchlist', data: {type: 'OBJECT', id: hotel.id, name: hotel.code}}))}} />
      </TableCell>
    </TableRow>
  )
}



/**
 * 
 * @returns 
 */
const Max2SearchResult = () => {
  // local state
  const [isLoading, setIsLoading] = useState(false);

  // global State
  const dispatch = useDispatch();
  const searchResult    = useSelector((state) => state.search.result)
  const isFiltered      = useSelector((state) => state.search.isFiltered)
  const isSearching     = useSelector((state) => state.search.isSearching)
  const searchFilter    = useSelector((state) => state.search.filter);
  const pagination      = useSelector((state) => state.search.pagination);
  const sorting         = useSelector((state) => state.search.sorting);
  const backendUrl      = useSelector((state) => state.app.backend.baseProtocol) + '://' + useSelector((state) => state.app.backend.url);

  // Snackbar
  const { enqueueSnackbar } = useSnackbar();

  const { t } = useTranslation();

  

  // Define references
  const loadMoreRef = useRef(null);



  /**
   * Load additional records
   */
  const loadMoreItems = useCallback(() => {
    // show load more animation
    setIsLoading(true);
    
    // Controller for AJAX requests
    const api = new AjaxController(backendUrl, () => {
      dispatch(setActivePage('START'));
      dispatch(setUser(null));
      dispatch(setToken(null));
    });
    
    // encode filter params object
    const query = {
      filter: searchFilter, 
      pagination: {
        ...pagination,
        actualPage: (pagination.actualPage+1)
      },
      sorting: sorting
    }
    
    // search for hotels
    const fetchData = async () => {
      try {
        const response = await api.get('/filter/' + btoa(JSON.stringify(query)).replaceAll('=', '_'));

        // hide load more animation
        setIsLoading(false);

        // extend result list
        dispatch(addResult(response))

      } catch (err) {
        console.error(err.message)
      }
    };

    fetchData();
  }, [backendUrl, dispatch, pagination, searchFilter, sorting]);


  // Get view mode from localStorage or default to 'table'
  const [viewMode, setViewMode] = useState(() => {
    return localStorage.getItem('resultListViewMode') || 'table';
  });
  
  // Save view mode to localStorage when it changes
  useEffect(() => {
    localStorage.setItem('resultListViewMode', viewMode);
  }, [viewMode]);


  /**
   * Initialize the scoll observer
   */
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          loadMoreItems();
        }
      },
      { threshold: 1.0 }
    );

    const currentRef = loadMoreRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [loadMoreItems]);



  /**
   * 
   * @param {string} by 
   * @param {string} direction 
   */
  const handleSortingClick = (by, direction) => {

    // encode filter params object
    const query = {
      filter: searchFilter, 
      pagination: pagination,
      sorting: {
        by : by, 
        direction: direction
      }
    }

    // Controller for AJAX requests
    const api = new AjaxController(backendUrl, () => {
          dispatch(setActivePage('START'));
          dispatch(setUser(null));
          dispatch(setToken(null));
        });
    
    // search for hotels
    const fetchData = async () => {
      try {

        // send search request
        const count = await api.get('/count/' + btoa(JSON.stringify(query)).replaceAll('=', '_'));

        const response = await api.get('/filter/' + btoa(JSON.stringify(query)).replaceAll('=', '_'));

        // display results
        dispatch(setResult({result: response, numberOfRecordsTotal: count, sorting: {by : by, direction: direction}}))

      } catch (err) {
        //setError(err.message);
        console.error(err.message)
      }
    };

    fetchData();

  }



  const handleMewObjectClick = useCallback(async () => {
    // Controller for AJAX requests
    const api = new AjaxController(backendUrl, () => {
      dispatch(setActivePage('START'));
      dispatch(setUser(null));
      dispatch(setToken(null));
    });

    try {
      const response = await api.get('/hotel/new/dummy');
      if (!response) {
        throw new Error(); 
      }

      dispatch(resetObject());
      dispatch(setActivePage('OBJECT'));
      dispatch(setObjectId('__new__'));
      if (typeof response.object === 'object') {
        dispatch(setObjectData(response.object));
      }
      if (typeof response.meta === 'object') {
        dispatch(setMetaData(response.meta));
      }
    } catch (error) {
      enqueueSnackbar(t('search.result.newHotelError'), { variant: 'error' });
      return;
    }
  }, [dispatch, backendUrl, enqueueSnackbar, t])


  
  // Build result records
  const resultItems = !isNaN(searchResult.numberOfRecords) ? searchResult.records.map((hotel) => {
    const key = hotel.id + '-' + hotel.giata;
    return viewMode === 'item' 
      ? <Max2SearchResultItem hotel={hotel} key={key} />
      : <Max2SearchResultRow hotel={hotel} key={key} />
  }) : <></>;

  // loading animation
  if (isSearching) {
    return (
      <Segment textAlign='left' style={{margin: '25px'}}>
        <Header as='h2' textAlign='center'>
          <Icon loading name='spinner' />
          <HeaderContent>
            {t('search.result.loading')}
          </HeaderContent>
        </Header>
      </Segment>
    )
  }

  // not yet filtered
  if (!searchResult.numberOfRecords && !isFiltered) {
    return <></>;
  }

  // Check if filter result contains records
  if (!searchResult.numberOfRecords) {
    return (
      <Segment textAlign='left' style={{margin: '25px'}}>
        <Header as='h2' textAlign='center'>
          <Icon name='ban' />
          <HeaderContent>
            {t('search.result.noResults.title')}
          </HeaderContent>
        </Header>
        <List bulleted style={{marginLeft: '66px'}}>
          <ListItem>{t('search.result.noResults.checkSpelling')}</ListItem>
          <ListItem>{t('search.result.noResults.reduceFilters')}</ListItem>
        </List>
      </Segment>
    )
  }
  
  //
  return (
    <Segment textAlign='left' style={{margin: '25px'}}>
      <Label circular style={{marginBottom: '20px'}}><span style={{fontSize: '1.4em', margin: '10px'}}>Hotels  ({searchResult.numberOfRecords} von {searchResult.numberOfRecordsTotal})</span></Label>
      <Grid columns={2}>
        <GridRow>
          <GridColumn>
            {t('search.result.sort.label')}
          
            <span style={{marginLeft:"15px"}}>
              {sorting.by === 'code' ? (
                <Button basic circular size='mini' color='blue' icon labelPosition='right' onClick={() => handleSortingClick('code', sorting.direction === 'ASC' ? 'DESC' : 'ASC')}><Icon name={sorting.direction === 'ASC' ? 'angle up' : 'angle down'}/>{t('search.result.sort.byCode')}</Button>
              ) : (
                <Button basic circular size='mini' onClick={() => handleSortingClick('code', 'ASC')}>{t('search.result.sort.byCode')}</Button>
              )}
            </span>
          
            <span style={{marginLeft:"15px"}}>
              {sorting.by === 'name' ? (
                <Button basic circular size='mini' color='blue' icon labelPosition='right' onClick={() => handleSortingClick('name', sorting.direction === 'ASC' ? 'DESC' : 'ASC')}><Icon name={sorting.direction === 'ASC' ? 'angle up' : 'angle down'}/>{t('search.result.sort.byName')}</Button>
              ) : (
                <Button basic circular size='mini' onClick={() => handleSortingClick('name', 'ASC')}>{t('search.result.sort.byName')}</Button>
              )}
            </span>
          
            <span style={{marginLeft:"15px"}}>
              {sorting.by === 'giata' ? (
                <Button basic circular size='mini' color='blue' icon labelPosition='right' onClick={() => handleSortingClick('giata', sorting.direction === 'ASC' ? 'DESC' : 'ASC')}><Icon name={sorting.direction === 'ASC' ? 'angle up' : 'angle down'}/>{t('search.result.sort.byGiata')}</Button>
              ) : (
                <Button basic circular size='mini' onClick={() => handleSortingClick('giata', 'ASC')}>{t('search.result.sort.byGiata')}</Button>
              )}
            </span>
          </GridColumn>
          <GridColumn textAlign='right'>
            {t('search.result.viewMode.label')}
            <Button.Group style={{marginLeft: '15px'}}>
              <Button
                icon='table'
                active={viewMode === 'table'}
                onClick={() => setViewMode('table')}
                title={t('search.result.viewMode.table')}
              />
              <Button
                icon='grid layout'
                active={viewMode === 'item'}
                onClick={() => setViewMode('item')}
                title={t('search.result.viewMode.item')}
              />
            </Button.Group>
          </GridColumn>
        </GridRow>
      </Grid>
      <Divider />
      <div style={{overflow: 'auto', height: 'calc(100vh - 630px)', padding: '10px'}}>
        {viewMode === 'table' && (
          <Table singleLine striped style={{background: "#eee"}}>
            <TableHeader>
              <TableRow>
                <TableHeaderCell></TableHeaderCell>
                <TableHeaderCell>{t('search.result.header.code')}</TableHeaderCell>
                <TableHeaderCell>{t('search.result.header.name')}</TableHeaderCell>
                <TableHeaderCell>{t('search.result.header.giata')}</TableHeaderCell>
                <TableHeaderCell>{t('search.result.header.3lc')}</TableHeaderCell>
                <TableHeaderCell>{t('search.result.header.active')}</TableHeaderCell>
                <TableHeaderCell>{t('search.result.header.contracts')}</TableHeaderCell>
                <TableHeaderCell></TableHeaderCell>
              </TableRow>
            </TableHeader>
            <TableBody>
              {resultItems}
            </TableBody>
          </Table>
        )}
        {viewMode === 'item' && (
          <List animated divided relaxed>
            {resultItems}
          </List>
        )}
        
        {searchResult.numberOfRecords !==  searchResult.numberOfRecordsTotal && (
          <div ref={loadMoreRef} style={{ textAlign: "center", padding: "10px" }}>
            {isLoading ? (
              <Button basic circular loading icon><Icon loading name="spinner" />{t('search.result.loadingMore')}</Button>
            ) : (
              <Button basic circular onClick={loadMoreItems}>{t('common.more')}</Button>
            )}
          </div>
        )}
      </div>
      <Divider />
      <Button primary circular size='big' icon='add' floated='right' title='Neues Hotel-Objekt anlegen' onClick={()=>handleMewObjectClick()}></Button>
      <br />
      <br />
    </Segment>
  );
}

export default Max2SearchResult;
